import {
  Model,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';
import { getAllClassHierarchy } from 'src/utils/getAllClassHierarchy';

export const getSubClassesForIri = (
  model: ModelSnapshot | Model,
  classIri: string
) => {
  const hierarchyByIri = getAllClassHierarchy(model);
  return Object.keys(hierarchyByIri[classIri].descendants);
};
